import React, { useEffect, useState } from 'react';
import { ReferenceArrayInput, required, TextInput } from 'react-admin';
import { RadioGroup, Radio, FormControlLabel, Grid } from '@material-ui/core';
import { memoize } from 'lodash';

import GridInputFilter from '../../core/components/inputs/GridInputFilter';
import {
  fieldLengthValidator,
  isFieldContainsOnlySpaces
} from '../../core/utils/index';

import InvestorTagApi from '../../core/apis/InvestorTagApi';
import { useStyles } from '../fundtags/FundTagSummary';

const InvestorTagSummary = props => {
  const classes = useStyles();
  const { creation, record, resetFilter, hasEditPermission } = props;

  const [formErrors, setFormErrors] = useState({});
  const [filter, setFilter] = useState(creation ? 'ALL' : 'ONLY_ASSIGNED');
  const selectedInvestorIds = record.investorIds;
  const disableCheckBoxes = creation ? false : !hasEditPermission;

  useEffect(() => {
    if (!creation && resetFilter) {
      setFilter('ONLY_ASSIGNED');
    }
  }, [creation, resetFilter]);

  const validateInvestorTagName = memoize(
    async (value, _allValues, fieldState) => {
      if (record && value === record.name) {
        return;
      }
      if (fieldState.active) {
        const investorTagNameValid = !!value.trim();
        let error;

        if (!investorTagNameValid) {
          error = `Investor Tag Name can't be empty space(s)`;
        } else {
          const nameExists = await InvestorTagApi.checkInvestorTagNameExists(
            value
          );
          if (nameExists) {
            error = 'Investor Tag Name already exists';
          } else {
            error = undefined;
          }
        }
        setFormErrors({ ...formErrors, name: error });
        return error;
      }
      return formErrors.name;
    }
  );

  const filterFunction = choices => {
    if (filter === 'ALL') {
      return choices;
    }
    if (typeof choices !== 'undefined') {
      return choices.filter(choice => {
        return !!selectedInvestorIds.find(item => item === choice.id);
      });
    }
  };

  const ReferenceArrayInputProps = {
    label: '',
    optionTextLabel: 'Investor Name',
    optionValueLabel: 'Investor ID',
    additionalColumns: [
      { label: 'Status', name: 'status', isStatusColumn: true }
    ],
    resource: 'investors',
    reference: 'investors',
    source: 'investorIds',
    filter: { orphanVisibility: 'ALL_VISIBLE' }
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.gridItem}>
          <Grid item xs={3} className={classes.gridItem}>
            <TextInput
              source="name"
              label="Tag Name"
              validate={[
                required(),
                isFieldContainsOnlySpaces,
                fieldLengthValidator(30),
                validateInvestorTagName
              ]}
              helperText={false}
              variant="standard"
              options={{ autoComplete: 'off' }}
            />
          </Grid>
          <Grid item xs={12} className={classes.gridItem}>
            <TextInput
              source="description"
              label="Description"
              validate={[isFieldContainsOnlySpaces, fieldLengthValidator(1000)]}
              options={{ autoComplete: 'off' }}
              variant="standard"
              helperText={false}
              multiline={true}
              rows="3"
            />
          </Grid>
        </Grid>
        <Grid item xs={12} className={`${classes.gridItemRelative}`}>
          {!creation && (
            <RadioGroup
              row
              className={classes.radioGroup}
              aria-label="radioFilter"
              name="radioFilter"
              onChange={({ target }) => setFilter(target.value)}
              value={filter}
            >
              <FormControlLabel
                value="ALL"
                label="Show All"
                control={<Radio color="primary" />}
              />
              <FormControlLabel
                value="ONLY_ASSIGNED"
                label="Show Assigned"
                control={<Radio color="primary" />}
              />
            </RadioGroup>
          )}
          <ReferenceArrayInput
            {...ReferenceArrayInputProps}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={-1}
          >
            <GridInputFilter
              height={
                creation
                  ? `${document.documentElement.scrollHeight - 500}px`
                  : `${document.documentElement.scrollHeight - 530}px`
              }
              optionText="name"
              optionValue="id"
              filter={filterFunction}
              disableCheckBoxes={disableCheckBoxes}
              emptyMessage={'There are no Investors assigned.'}
            />
          </ReferenceArrayInput>
        </Grid>
      </Grid>
    </div>
  );
};

export default InvestorTagSummary;
